









































import Vue from 'vue';
import { mapState } from 'vuex';
import { HotelInterface } from '@/types/hotelInterface';
import { AppScope } from '@/constants/appScope';

export default Vue.extend({
  name: 'LegalInfoModal',
  data: () => ({
    isOpen: false,
    info: {} as any,
    loading: true,
  }),
  computed: {
    ...mapState({
      hotel(state: any): HotelInterface {
        const scope = this.getScope();
        return scope === AppScope.Dashboard ? state.dashboard.hotel : state.landing.hotel.item;
      },
    }),
  },
  mounted() {
    this.$store
      .dispatch('landing/hotel/getLegalInfo', this.hotel.hotel_hid)
      .then(res => {
        if (res && res.data && res.data.legal_info) {
          this.info = { ...res.data.legal_info };
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    getInfoField(key: string): string {
      if (this.info[this.i18nTag()] && this.info[this.i18nTag()][key]) {
        return this.info[this.i18nTag()][key];
      }
      if (this.info.en && this.info.en[key]) {
        return this.info.en[key];
      }
      return this.info.ja[key];
    },
  },
});
